import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton, Switch, Tooltip } from "@mui/material";
import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { putSuborganizationById } from "../../../../api/broker";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import {
  Estado
} from "../../../../interfaces/SuperAdmin/Others/iDataEstado";
import {
  iDataSuborganizacion,
  PutSuborgFields,
} from "../../../../interfaces/SuperAdmin/Pages/iDataSuborganizacion";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";

interface Props {
  suborg: iDataSuborganizacion;
  index: number;
}

const RowSuborg: FC<Props> = ({ suborg, index }) => {
  const { handleEditSuborg, assignToDeleteSuborg } = useSuperAdminSingleOrg();

  const navigate = useNavigate();
  const { idOrganization } = useParams();

  const [isActive, setIsActive] = useState(suborg.estado === Estado.ACTIVO);

  const toggleActive = async () => {
    const body = { estado: isActive ? Estado.INACTIVO : Estado.ACTIVO };

    try {
      const res = await putSuborganizationById(
        body as PutSuborgFields,
        suborg.id_suborganizacion
      );
      console.log(res);

      if (res.data.statusCode === 200) {
        setIsActive((prev) => !prev);
        toast.success(
          `Suborganización ${
            isActive ? "desactivada" : "activada"
          } exitosamente`
        );
      } else {
        toast.error(
          `Error al  ${isActive ? "desactivar" : "activar"} la suborganización`
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        `Error al  ${isActive ? "desactivar" : "activar"} la suborganización`
      );
    }
  };

  return (
    <StyledTableRow>
      <StyledTableCell>{index + 1}</StyledTableCell>
      <StyledTableCell>{suborg.suborganizacion}</StyledTableCell>
      <StyledTableCell align="center">
        <Switch
          checked={isActive}
          onChange={toggleActive}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "#2E7D32",
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#2E7D32",
            },
          }}
        />
      </StyledTableCell>
      <StyledTableCell align="center">
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEditSuborg(suborg)}
        >
          <Tooltip title="Editar suborganización">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>

        <Button
          sx={{ color: "#336B87" }}
          onClick={() => assignToDeleteSuborg(suborg.id_suborganizacion)}
        >
          <Tooltip title="Eliminar suborganización">
            <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() =>
            navigate(
              `/asistente/organizations/${idOrganization}/suborganizations/${suborg.id_suborganizacion}`
            )
          }
        >
          <Tooltip title="Ver suborganización">
            <IconButton aria-label="suborganización" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RowSuborg;
